import * as React from "react"

import { cn } from "@/lib/utils"

// Steel & Ember — Card primitive.
// `variant="mission"` paints an obsidian gradient surface for mission-control
// hero blocks (admin overview, dashboard KPI strips, landing tiles).
const Card = React.forwardRef(({ className, variant = "default", ...props }, ref) => {
  const variants = {
    default: "bg-card text-card-foreground border-border shadow-sm",
    inset:   "bg-[color:var(--card-bg-alt)] text-card-foreground border-[color:var(--border-subtle)] shadow-inner",
    mission: "text-white border-[color:var(--border-color)] shadow-[0_24px_60px_-20px_rgba(0,0,0,0.6)] bg-gradient-to-br from-[#0A0A0A] via-[#121212] to-[#27272A] overflow-hidden",
  };
  return (
    <div
      ref={ref}
      className={cn("rounded-xl border", variants[variant] || variants.default, className)}
      {...props}
    />
  );
})
Card.displayName = "Card"

const CardHeader = React.forwardRef(({ className, ...props }, ref) => (
  <div ref={ref} className={cn("flex flex-col space-y-1.5 p-6", className)} {...props} />
))
CardHeader.displayName = "CardHeader"

const CardTitle = React.forwardRef(({ className, ...props }, ref) => (
  <div ref={ref} className={cn("text-base font-semibold leading-tight tracking-tight", className)} {...props} />
))
CardTitle.displayName = "CardTitle"

const CardDescription = React.forwardRef(({ className, ...props }, ref) => (
  <div ref={ref} className={cn("text-sm text-muted-foreground", className)} {...props} />
))
CardDescription.displayName = "CardDescription"

const CardContent = React.forwardRef(({ className, ...props }, ref) => (
  <div ref={ref} className={cn("p-6 pt-0", className)} {...props} />
))
CardContent.displayName = "CardContent"

const CardFooter = React.forwardRef(({ className, ...props }, ref) => (
  <div ref={ref} className={cn("flex items-center p-6 pt-0", className)} {...props} />
))
CardFooter.displayName = "CardFooter"

export { Card, CardHeader, CardFooter, CardTitle, CardDescription, CardContent }
